import React from 'react';
import "./footer.css";
import ScrollUp from './ScrollUp';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer_container container">
                <h1 className="footer_title">Vrushal</h1>

                <ul className="footer_list">
                    <li><a href="#about" className="footer_link">About</a></li>
                    <li><a href="#skills" className="footer_link">Skills</a></li>
                    <li><a href="#services" className="footer_link">Portfolio</a></li>
                    <li><a href="#portfolio" className="footer_link">Portfolio</a></li>
                </ul>

                <div className="footer_social">
                    <a href="https://www.linkedin.com/in/vrushal-shahare/" className="footer_social-link">
                        <i className="bx bxl-linkedin"></i>
                    </a>

                    <a href="https://twitter.com/vrushal_shahare" className="footer_social-link">
                        <i className="bx bxl-twitter"></i>
                    </a>

                    <a href="https://github.com/Vrushal143" className="footer_social-link">
                        <i className="bx bxl-github"></i>
                    </a>
                </div>

                <span className='footer_copy'>&#169; Crypticalcoder. All rights reserved</span>
            </div >

            <ScrollUp />






        </footer >
    );
};

export default Footer;
